export function updateGridTemplateAddButtonState(gridViewTemplate) {
    const addBtn = $('.add-button .add-grid-item');

    const hasSelection = gridViewTemplate
        .multipleSelect('getSelects')
        .length > 0;

    addBtn.prop('disabled', !hasSelection);
}